import { useEffect, useMemo } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';

import { socketOff, socketOn } from 'lib/clients/socket';
import { useOutboundFaxes } from 'lib/hooks/queries/fax/useOutboundFaxes';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import ButtonActions from './ButtonActions';
import DocumentFaxModal from './DocumentFaxModal';
import { DEFAULT_FILTERS, getColDefs } from './configs';

const NewOutboundFaxes = () => {
  const currPractice = useRecoilValue(currentPractice);
  const timezone = currPractice?.timezone;
  const queryClient = useQueryClient();

  const columnDefs = useMemo(() => getColDefs({ timezone }), [timezone]);

  useEffect(() => {
    socketOn('outbound_fax', (data) => {
      const fax = data?.fax;
      queryClient.setQueryData(['outboundFaxes'], (prev) => [...prev, fax]);
    });

    return () => {
      socketOff('outbound_fax');
    };
  }, []);

  return (
    <AgTablePage
      ModalComponent={DocumentFaxModal}
      defaultFilters={DEFAULT_FILTERS}
      defaultColumns={columnDefs}
      queryKey="outboundFaxes"
      name="outbound_faxes"
      title="Outbound Faxes"
      disabledCells={['tagLinks']}
      useData={useOutboundFaxes}
      rowStyle={{ cursor: 'pointer' }}
      actions={ButtonActions}
      noNewButton
    />
  );
};

export default NewOutboundFaxes;
